import { render } from "./RankingList.vue?vue&type=template&id=08a6db3a"
import script from "./RankingList.vue?vue&type=script&lang=js"
export * from "./RankingList.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__